import Carousel from './carousel';

class PrimaryTeaserCarousel extends Carousel {
  constructor(selector: any = '.js-primary-teaser-carousel', settings: object = {}) {
    const TIME = 5000;
    const SPEED = 800;

    const el = selector instanceof HTMLElement
      ? selector
      : document.querySelector(selector);
    const pagination: HTMLElement | null | undefined = el?.parentElement?.querySelector('.o-primary-teaser-image-slider__pagination');

    super(el, {
      ...settings,
      effect: 'slide',
      autoHeight: false,
      speed: SPEED,
      slidesPerView: el?.classList.contains('js-primary-teaser-slider') ? 1.3 : 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      autoplay: false,
      // autoplay: {
      //   delay: TIME,
      // },
      centeredSlides: true,
      navigation: {
        nextEl: el?.parentElement?.querySelectorAll('.swiper-button-next, .o-primary-teaser-slider__swiper-button-next')[0],
        prevEl: el?.parentElement?.querySelectorAll('.swiper-button-prev, .o-primary-teaser-slider__swiper-button-prev')[0],
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      // on: {
      //   afterInit: () => {
      //     pagination?.style.setProperty('--time', `${(TIME + (SPEED / 2)) / 1000}s`);
      //   },
      // },
      breakpoints: {
        768: {
          slidesPerView: 1,
        },
      },
    });
  }
}

export default PrimaryTeaserCarousel;
